export const VIBRATION_LEVEL_TITLE = 'VIBRATION-LEVEL.TITLE';
export const BERING_SPINDLE_TITLE = 'BERING-SPINDLE.TITLE';
export const TOOLTIP_DATA_ASSET_HEALTH = 'TOOLTIP.ASSET-HEALTH';
export const ASSET_HEALTH_TITLE = 'ASSET-HEALTH-INDICATOR.TITLE';
export const NEXT_SERVICE_TITLE = 'NEXT-SERVICE.TITLE';
export const MIN_LABEL = 'CHART-LEGEND.POOR';
export const MAX_LABEL = 'CHART-LEGEND.GOOD';
export const TOOLTIP_VIBRATION_LEVEL = 'TOOLTIP.VIBRATION-LEVEL';
export const TOOLTIP_BERING_SPINDLE = 'TOOLTIP.BERING-SPINDLE';
export const PAGE_SECTION_PRODUCTION = 'PAGE-SECTION.PRODUCTION';
export const PAGE_SECTION_CIP = 'PAGE-SECTION.CIP';
export const DATA_QUALITY_TITLE = 'DATA-QUALITY.TITLE';
export const TIME_USE_TITLE = 'TIME-USE.TITLE';
export const TOOLTIP_DATA_QUALITY = 'TOOLTIP.DATA-QUALITY';
export const OPERATING_HOURS_TITLE = 'OPERATING-HOURS.TITLE';
export const CIP_CYCLES_TITLE = 'CIP-CYCLES.TITLE';
export const LOCAL_ALARM_TITLE = 'LOCAL-ALARMS.TITLE';
export const STARTS_TITLE = 'STARTS.TITLE';
export const SEPARATION_POWER_CONSUMPTION_UNIT = 'SEPARATION-KPI.AVERAGE-POWER-CONSUMPTION.UNIT';
export const POWER_CONSUMPTION_UNIT = 'SEPARATION.AVERAGE-POWER-CONSUMPTION.UNIT';
export const AVERAGE_POWER_CONSUMPTION_TITLE = 'AVERAGE-POWER-CONSUMPTION.TITLE';
export const NETWORK_ERROR_TITLE = 'NETWORK-ERROR.TITLE';
export const NETWORK_NEXT_SERVICE_ERROR_TITLE = 'NETWORK-NEXT-SERVICE-ERROR.TITLE';
export const NETWORK_ERROR_MESSAGE = 'NETWORK-ERROR.MESSAGE';
export const OVERVIEW_HOUR = 'OVERVIEW.HOUR-UNIT';
export const OVERVIEW_MIN = 'OVERVIEW.MINUTE-UNIT';
export const OVERVIEW_SECONDS = 'OVERVIEW.SECONDS-UNIT';
export const OVERVIEW_TIME_AGO = 'OVERVIEW.RELATIVE-PAST';
export const OVERVIEW_NO_SENSOR_DATA = 'OVERVIEW.MISSING-SENSOR-DATA';
export const DASHBOARD_NO_RESULTS_INFO_TEXT = 'MACHINE-DASHBOARD-PAGE.NO-RESULTS-INFO-TEXT';
export const BERING_LIQUIDE_SIDE = 'BERING-LIQUIDE-SIDE';
export const TOOLTIP_BERING_LIQUIDE_SIDE = 'TOOLTIP-BERING-LIQUIDE-SIDE';
export const BERING_SOLID_SIDE = 'BERING-SOLID-SIDE';
export const TOOLTIP_BERING_SOLID_SIDE = 'TOOLTIP-BERING-SOLID-SIDE';
export const MOTOR_PLATE = 'MOTOR-PLATE';
export const TOOLTIP_MOTOR_PLATE = 'TOOLTIP-MOTOR-PLATE';
export const BERING_MOTOR = 'BERING-MOTOR';
export const TOOLTIP_BERING_MOTOR = 'TOOLTIP-BERING-MOTOR';
export const UNIT_KWH = 'UNIT.KWH';
export const UNIT_MIN = 'UNIT.MIN';
export const UNIT_LITER = 'UNIT.LITER';
export const UNIT_M3 = 'UNIT.M3';
export const UNIT_H = 'UNIT.H';
export const CHART_SERIES_FLOW = 'CHART-SERIES.FLOW';
export const CHART_SERIES_SKIMMED_MILK = 'CHART-SERIES.SKIMMED-MILK';
export const CHART_SERIES_CREAM_FLOW = 'CHART-SERIES.CREAM-FLOW';
export const CHART_SERIES_CONSUMPTION = 'CHART-SERIES.CONSUMPTION';
export const CHART_SERIES_TIME_USE = 'CHART-SERIES.TIME-USE';
export const DASHBOARD_SEARCH_PLACEHOLDER = 'MACHINE-DASHBOARD-PAGE.SEARCH-PLACEHOLDER';
export const DASHBOARD_PAGE_TITLE = 'MACHINE-DASHBOARD-PAGE.TITLE';
export const VIBRATION_FRAME = 'VIBRATION-FRAME';
export const TOOLTIP_VIBRATION_FRAME = 'TOOLTIP-VIBRATION-FRAME';
